import {
  enumeratedLiterals,
  type EnumeratedLiteralType,
} from "./enumeratedLiterals";

export const TimeGranularities = enumeratedLiterals(
  ["monthly", "weekly", "daily", "hourly"] as const,
  {
    getLabels: (accessors) =>
      ({
        [accessors.MONTHLY]: "Monthly",
        [accessors.WEEKLY]: "Weekly",
        [accessors.DAILY]: "Daily",
        [accessors.HOURLY]: "Hourly",
      } as const),
    getAttributes: (accessors) =>
      ({
        [accessors.MONTHLY]: {
          maxLookbackDays: 20 * 365,
          maxLookbackCompareDays: 20 * 365,
        },
        [accessors.DAILY]: {
          maxLookbackDays: 20 * 365,
          maxLookbackCompareDays: 20 * 365,
        },
        [accessors.HOURLY]: {
          maxLookbackDays: 8,
          maxLookbackCompareDays: 15,
        },
        [accessors.WEEKLY]: {
          maxLookbackDays: 20 * 365,
          maxLookbackCompareDays: 20 * 365,
        },
      } as const),
  },
);

export type TimeGranularity = EnumeratedLiteralType<typeof TimeGranularities>;
